"use client";
import Link from "next/link";
import type { ComponentProps } from "react";
import { menuStore } from "../MenuInner";

type Props = ComponentProps<typeof Link>;
export const ExtendedLink = ({ children, className, ...rest }: Props) => {
  return (
    <Link
      className="text-xs font-medium text-tx-1 hover:text-pr-1 group w-fit px-1 py-[3px] rounded-sm bg-transparent hover:bg-bg-2 -mx-1 -my-[3px]"
      onClick={() => menuStore.set(null)}
      {...rest}
    >
      {children}
    </Link>
  );
};
